@if (!error) {
  <rt-select
    [formControl]="input.control"
    [options]="resourceSelectOptions"
    [hasSearch]="showSearch()"
    [placeholder]="selectPlaceholder"
    [includeEmptyOption]="input.includeEmptyOption"
    [multiple]="input.multiple"
    [closeOnSelect]="!input.multiple"
  >
  </rt-select>

  @if (showSpinner) {
    <rt-spinner variant="small"></rt-spinner>
  }
}

@if (error && loading) {
  <rt-select
    [formControl]="input.control"
    [options]="[]"
    [hasSearch]="false"
    [placeholder]="selectPlaceholder"
    [includeEmptyOption]="false"
  >
  </rt-select>
}

@if (error && !loading) {
  {{ error }}
}
